import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { rateReviewComment } from '@app/app/pdp/pdp-model';
import { DeviceService, EventTrackerService, HttpService } from '@app/core';
import { TokenService } from '@app/core/token/token.service';
import { NotificationService } from '@app/shared/notification/notification.service';
import { SubscriptionLike } from 'rxjs';


@Component({
  selector: 'navaar-send-rate-and-comment',
  templateUrl: './send-rate-and-comment.component.html',
  styleUrls: ['./send-rate-and-comment.component.scss']
})
export class SendRateAndCommentComponent implements OnInit, OnDestroy {
  @Output('onSubmit') public _onDone: EventEmitter<{ index: number }> = new EventEmitter<{ index: number }>();
  @Output('onBack') public _onBack: EventEmitter<{ index: number }> = new EventEmitter<{ index: number }>();
  @Input('show') public isShowRate: boolean = false;
  @Input('audiobook-id') public audiobookId: string;
  @Input() public identifier: number;
  @Input('rate') public ratoToComment: number;
  @Input('main-rate') private oldRateValue: number;
  @Output('rateChange') public ratoToCommentChange: EventEmitter<number> = new EventEmitter<number>();
  @Input('title') public title: string;
  @Input() public isShowEmptyTemplate: boolean = false;
  public model: rateReviewComment = { commentText: '' };
  public submitted: boolean = false;
  private _location: SubscriptionLike;
  public isLogin = false;

  constructor(
    private readonly tokenService: TokenService,
    private readonly device: DeviceService,
    private readonly eventTracker: EventTrackerService,
    private readonly chkd: ChangeDetectorRef,
    private readonly notification: NotificationService,
    public readonly location: Location,
    private readonly http: HttpService) { }
  ngOnInit(): void {
    this.tokenService.isLogin$.subscribe(c => this.isLogin = c);
    this._location = this.location.subscribe(c => {
      if (this.isShowRate)
        this.onBackKey(false);
    });
  }

  public onSaveComment() {
    if (!this.isLogin) {
      this.device.goTologinPageNative(`/pdp/comment/${this.audiobookId}/${this.identifier}?title=${this.title}`);
      return;
    }
    this.model.ratingValue = this.ratoToComment;
    this.model.audiobookId = this.audiobookId;
    if (!this.model.ratingValue || this.model.ratingValue <= 0) {
      this.notification.setNotification({
        text: 'لطفا به این اثر امتیاز دهید',
        type: 'warning'
      });
      return;
    }
    this.eventTracker.logEvent('x_btn_add_comment', {
      item_id: this.audiobookId,
      title: this.title,
      rate: this.model.ratingValue
    });
    this.submitted = true;
    this.http.post('/api/ratereview', JSON.stringify(this.model)).subscribe(c => {
      this.notification.setNotification({
        text: 'نظر شما ثبت شد.پس از تایید، نمایش داده میشود',
        type: 'info'
      });
      this.isShowRate = false;
      this._onDone.emit({ index: this.model.ratingValue });
      this.ratoToCommentChange.emit(this.model.ratingValue);
      this.oldRateValue = this.model.ratingValue;
      this.model.commentText = '';
      this.chkd.detectChanges();
    }, () => {
      this.notification.setNotification({
        text: 'نظر ثبت نگردید',
        type: 'error'
      });
    }, () => {
      this.submitted = false;
      this.chkd.markForCheck();
    });

    ;
  }
  public onBackKey(e) {
    this.eventTracker.logEvent('x_btn_back_key_comment', {
      item_id: this.audiobookId,
      title: this.title
    });
    this.ratoToCommentChange.emit(this.oldRateValue);
    this.isShowRate = e;
    this.model.commentText = '';
    this._onBack.emit({ index: this.oldRateValue });
  }

  public rateToComment(e) {
    this.ratoToComment = e['index'];
  }

  ngOnDestroy(): void {
    if (this._location)
      this._location.unsubscribe();
  }
}
